import {
  useState, useRef, useMemo, useEffect,
} from 'react';

import { apiContainer } from '@vlabs/api-bindings';
import { getGeneralEventsQS } from '@vlabs/api-bindings/src/luna-client/events/mappers';
import axios from 'axios';

export function useGeneralEventsTableData({ isReady, filters }) {
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(25);
  const [data, setData] = useState([]);
  const cancelRef = useRef(null);

  const filtersKey = useMemo(() => JSON.stringify(filters || {}), [filters]);

  useEffect(() => {
    if (!isReady) return;
    setPageIndex(0);
  }, [isReady, filtersKey]);

  useEffect(() => {
    if (!isReady) return;

    if (cancelRef.current) cancelRef.current.cancel();
    cancelRef.current = axios.CancelToken.source();

    const qs = getGeneralEventsQS({
      ...filters,
      page: pageIndex + 1,
      page_size: pageSize,
    });

    apiContainer.lunaClient.generalEvents
      .getAll(qs, { cancelToken: cancelRef.current.token })
      .then((resp) => {
        setData(resp ?? []);
      })
      .catch((e) => {
        if (axios.isCancel(e)) return;
        throw e;
      });

    return () => {
      if (cancelRef.current) cancelRef.current.cancel();
    };
  }, [isReady, filtersKey, pageIndex, pageSize]);

  return {
    data,
    pageIndex,
    setPageIndex,
    pageSize,
    setPageSize,
    pageSizeOptions: [10, 25, 50, 100],
  };
}
